(function () {
  const cfg = window.FLEDGLINGS_VOICE_SEARCH || {};
  const modal = document.getElementById('fledglings-voice-search-modal');
  const sheet = document.getElementById('fledglings-voice-search-sheet');
  const closeBtn = document.getElementById('fledglings-voice-search-close');
  const recordBtn = document.getElementById('fledglings-voice-search-record');
  const statusBox = document.getElementById('fledglings-voice-search-status');
  const resultsBox = document.getElementById('fledglings-voice-search-results');
  const heading = document.getElementById('fledglings-voice-search-heading');
  const subtitle = document.getElementById('fledglings-voice-search-subtitle');
  const fallbackLauncher = document.getElementById('fledglings-voice-search-fallback');

  if (!modal || !sheet || !closeBtn || !recordBtn || !statusBox || !resultsBox || !heading || !subtitle) {
    return;
  }

  if (!window.MediaRecorder || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    if (fallbackLauncher) fallbackLauncher.style.display = 'none';
    return;
  }

  heading.textContent = cfg.title || 'Voice search';
  subtitle.textContent = cfg.subtitle || 'Tell us what you need and we will find the closest matches.';

  let mediaRecorder = null;
  let chunks = [];
  let stream = null;
  let isRecording = false;

  function micSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 15.5a3.75 3.75 0 0 0 3.75-3.75v-5.5a3.75 3.75 0 1 0-7.5 0v5.5A3.75 3.75 0 0 0 12 15.5Zm6-3.75a.75.75 0 0 0-1.5 0 4.5 4.5 0 1 1-9 0 .75.75 0 0 0-1.5 0 6.01 6.01 0 0 0 5.25 5.95V20.5H9.5a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-1.75v-2.8A6.01 6.01 0 0 0 18 11.75Z"/></svg>';
  }

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    if (isRecording) {
      stopRecording();
    }
  }

  function setStatus(text) {
    statusBox.textContent = text;
  }

  function renderResults(data) {
    resultsBox.innerHTML = '';

    if (data && data.transcript) {
      const heard = document.createElement('p');
      heard.style.fontSize = '13px';
      heard.style.color = '#0f172a';
      heard.textContent = 'Heard: ' + data.transcript;
      resultsBox.appendChild(heard);
    }

    if (!data || !data.results || !data.results.length) {
      const empty = document.createElement('p');
      empty.textContent = 'No close matches found. Try a simpler description.';
      resultsBox.appendChild(empty);
      return;
    }

    data.results.forEach(function (item) {
      const a = document.createElement('a');
      a.className = 'fv-card';
      a.href = item.url || '#';

      const imageHtml = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.image_alt || '') + '">'
        : '<img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==" alt="">';

      a.innerHTML = [
        imageHtml,
        '<div>',
          '<h4>' + escapeHtml(item.title || '') + '</h4>',
          '<p>' + escapeHtml(item.description || '') + '</p>',
          '<div class="fv-price">' + escapeHtml(formatPrice(item.price)) + '</div>',
          item.reason ? '<div class="fv-reason">' + escapeHtml(item.reason) + '</div>' : '',
        '</div>'
      ].join('');

      resultsBox.appendChild(a);
    });
  }

  function formatPrice(price) {
    if (!price || !price.amount) return '';

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: price.currency || 'GBP'
      }).format(Number(price.amount));
    } catch (e) {
      return String(price.amount) + ' ' + (price.currency || 'GBP');
    }
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function createTrigger(className, label) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'fv-search-trigger ' + className;
    button.setAttribute('aria-label', label || 'Open voice search');
    button.setAttribute('title', label || 'Open voice search');
    button.setAttribute('data-fv-voice-button', '1');
    button.innerHTML = micSvg();
    button.addEventListener('click', openModal);
    return button;
  }

  function injectDesktop() {
    const desktopTargets = [
      '.header__search-input form.search .search__button',
      '.header-nav-left-aligned form.search .search__button',
      '.header-nav-full-elements form.search .search__button',
      '.header-navigation form.search .search__button',
      '.search-modal__form .search__button'
    ];

    let count = 0;

    desktopTargets.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (target) {
        if (!target || target.parentElement?.querySelector('[data-fv-voice-search-wrap="desktop"]')) {
          return;
        }

        const wrap = document.createElement('span');
        wrap.className = 'fv-inline-search-wrap fv-inline-search-wrap--field';
        wrap.setAttribute('data-fv-voice-search-wrap', 'desktop');
        wrap.appendChild(createTrigger('fv-search-trigger--desktop', 'Search by voice'));
        target.insertAdjacentElement('afterend', wrap);
        count += 1;
      });
    });

    return count;
  }

  function injectMobile() {
    const mobileTargets = [
      'button.search__button.field__button.focus-inset',
      '.search-modal__form button.search__button',
      'form.search button.search__button'
    ];

    let count = 0;

    mobileTargets.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (target) {
        if (!target || target.closest('[data-fv-voice-search-wrap="mobile"]')) {
          return;
        }

        const host =
          target.closest('.header__icon, .header__iconItem, .header__icons, li, .list-social__item, .header-mobile--icon')
          || target.parentElement
          || target;

        if (!host || host.parentElement?.querySelector('[data-fv-voice-search-wrap="mobile"]')) {
          return;
        }

        const wrap = document.createElement('span');
        wrap.className = 'fv-mobile-search-wrap';
        wrap.setAttribute('data-fv-voice-search-wrap', 'mobile');
        wrap.appendChild(createTrigger('fv-search-trigger--mobile', 'Search by voice'));

        host.insertAdjacentElement('afterend', wrap);
        count += 1;
      });
    });

    return count;
  }

  function injectButtons() {
    document.querySelectorAll('[data-fv-voice-search-wrap]').forEach(function (node) {
      node.remove();
    });

    const desktopCount = injectDesktop();
    const mobileCount = injectMobile();
    const total = desktopCount + mobileCount;

    if (fallbackLauncher) {
      if (mobileCount > 0 || total > 0) {
        fallbackLauncher.hidden = true;
        fallbackLauncher.style.display = 'none';
      } else {
        fallbackLauncher.hidden = false;
        fallbackLauncher.style.display = '';
        fallbackLauncher.onclick = openModal;
      }
    }
  }

  async function startRecording() {
    if (isRecording) return;

    chunks = [];
    stream = await navigator.mediaDevices.getUserMedia({ audio: true });

    const options = {};
    if (window.MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported('audio/webm')) {
      options.mimeType = 'audio/webm';
    }

    mediaRecorder = new MediaRecorder(stream, options);

    mediaRecorder.addEventListener('dataavailable', function (event) {
      if (event.data && event.data.size) {
        chunks.push(event.data);
      }
    });

    mediaRecorder.addEventListener('stop', async function () {
      try {
        const mimeType = (mediaRecorder && mediaRecorder.mimeType) ? mediaRecorder.mimeType : 'audio/webm';
        const blob = new Blob(chunks, { type: mimeType });
        await sendAudio(blob);
      } finally {
        if (stream) {
          stream.getTracks().forEach(function (track) { track.stop(); });
        }
        stream = null;
      }
    });

    mediaRecorder.start();
    isRecording = true;
    recordBtn.textContent = '■';
    setStatus('Listening… tap again to stop.');
  }

  function stopRecording() {
    if (!mediaRecorder || !isRecording) return;

    isRecording = false;
    recordBtn.textContent = '🎙️';
    setStatus('Finding matches…');
    mediaRecorder.stop();
  }

  async function sendAudio(blob) {
    resultsBox.innerHTML = '';
    setStatus('Uploading recording…');

    const transcribeUrl = cfg.endpoint.replace(/\/$/, '') + '/transcribe';

    const formData = new FormData();
    formData.append('audio', blob, 'voice-search.webm');
    formData.append('lang', cfg.locale || 'en');

    const transcribeResponse = await fetch(transcribeUrl, {
      method: 'POST',
      headers: {
        'X-Fledglings-Search-Key': cfg.sharedKey || ''
      },
      body: formData
    });

    const transcribeRaw = await transcribeResponse.text();
    let transcribeData;

    try {
      transcribeData = JSON.parse(transcribeRaw);
    } catch (error) {
      throw new Error('Transcription returned non-JSON response: ' + transcribeRaw.substring(0, 300));
    }

    if (!transcribeResponse.ok || !transcribeData.ok) {
      throw new Error(transcribeData.detail || transcribeData.message || 'Transcription failed');
    }

    const transcript = String(transcribeData.transcript || '').trim();
    const heardText = transcript ? 'I heard: ' + transcript : 'I heard nothing useful.';

    setStatus(heardText);
    resultsBox.innerHTML = '<p>' + escapeHtml(heardText) + '</p>';

    const searchFormData = new FormData();
    searchFormData.append('transcript', transcript);
    searchFormData.append('lang', cfg.locale || 'en');

    const searchResponse = await fetch(cfg.endpoint, {
      method: 'POST',
      headers: {
        'X-Fledglings-Search-Key': cfg.sharedKey || ''
      },
      body: searchFormData
    });

    const searchRaw = await searchResponse.text();
    let searchData;

    try {
      searchData = JSON.parse(searchRaw);
    } catch (error) {
      throw new Error('Search returned non-JSON response: ' + searchRaw.substring(0, 300));
    }

    if (!searchResponse.ok || !searchData.ok) {
      throw new Error(searchData.detail || searchData.message || 'Search failed');
    }

    setStatus('Here are the best matches I found.');
    renderResults(searchData);
  }

  closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', function (event) {
    if (!sheet.contains(event.target)) {
      closeModal();
    }
  });

  recordBtn.addEventListener('click', function () {
    if (isRecording) {
      stopRecording();
      return;
    }

    startRecording().catch(function (error) {
      console.error(error);
      setStatus('Microphone permission was denied or unavailable.');
      resultsBox.innerHTML = '<p>' + escapeHtml(error.message || 'Voice search could not complete just now.') + '</p>';
    });
  });

  function scheduleInjection(attempt) {
    window.setTimeout(function () {
      injectButtons();
    }, attempt === 0 ? 0 : Math.min(300 * attempt, 1800));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      for (let i = 0; i < 8; i += 1) {
        scheduleInjection(i);
      }
    });
  } else {
    for (let i = 0; i < 8; i += 1) {
      scheduleInjection(i);
    }
  }
})();
